
<template>
  <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
      <span>{{name}}</span>
    </div>
    <div class="text item paramContainer">
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="4">
            URL
        </el-col>
        <el-col :span="20">
            <el-input
                placeholder="https://example.com/ (leave empty to inherit current url domain)"
                v-model="model.params.url"
                clearable>
            </el-input>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="4">
            Domain
        </el-col>
        <el-col :span="20">
            <el-input
                placeholder=".example.com (optional)"
                v-model="model.params.domain"
                clearable>
            </el-input>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="4">
            Name
        </el-col>
        <el-col :span="20">
            <el-input
                placeholder="Cookie name"
                v-model="model.params.name"
                clearable>
            </el-input>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="4">
            Value
        </el-col>
        <el-col :span="20">
            <el-input
                placeholder="Cookie value"
                v-model="model.params.value"
                clearable>
            </el-input>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="4">
            Expires
        </el-col>
        <el-col :span="20">
            <el-input
                placeholder="Cookie expiration string (+1 day, +1 year), optional"
                v-model="model.params.expires"
                clearable>
            </el-input>
        </el-col>
      </el-row>
      <div class="tip">
          {{desc}}
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SetCookie',
  data () {
    return {
      name: 'Set Cookie',
      desc: 'You can add browser cookie without visiting website. ' +
            'When expires is not set, the cookie will be an one time session cookie'
    }
  },
  props: {
    model: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
   
  },
  computed: {
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading'
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
